/*
 * The names of the drive's views in core's details column. They stand in a file of their own because
 * the module object (`../index.ts`) registers the views from the entry chunk, while the views
 * themselves and every page that opens them are chunks.
 */

/** Details of an item or a drive: who can open it, where it is, what it holds, its address. */
export const DETAILS_VIEW = "drive.details"

/** The views of the column that are tabs of one another: Details, Versions, Activity. */
export const DETAILS_GROUP = "drive.item"
